import FloatButton from "./FloatButton";

export default function ResumeFloatButton() {
  return <div style={{ position: 'absolute', top: '695px', left: '1430px' }}>
    <FloatButton text="Resume" />
  </div>;
}
